import React from 'react';

import { Button, Tooltip } from '@bringg/react-components';
import { useTranslation } from 'react-i18next';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { PrivilegeTypes } from '@bringg/types';

import { useHasAccess } from 'bringg-web';

import styles from './planned-delivery-windows-popover-content.module.scss';

interface HeaderSectionProps {
	title: string;
	onEditClick: () => void;
}

export const HeaderSection = ({ title, onEditClick }: HeaderSectionProps) => {
	const { t } = useTranslation();
	const hasAccessToEditByPrivilege = useHasAccess(PrivilegeTypes.EDIT_PLANNED_DELIVERY_WINDOWS);

	return (
		<div className={styles.header}>
			<div className={styles.title}>
				<Tooltip title={title}>{title}</Tooltip>
			</div>
			{hasAccessToEditByPrivilege && (
				<div className={styles.actions}>
					<Tooltip title={t('GLOBAL.EDIT')}>
						<Button
							icon={<BringgIcon iconName={BringgFontIcons.ShowMore} />}
							className={styles.gray600}
							shape="circle"
							type="text"
							onClick={onEditClick}
							data-test-id="planned-delivery-window-popover-content-edit"
						/>
					</Tooltip>
				</div>
			)}
		</div>
	);
};
